export enum ErrorsRoutePath {
    NotFound = '/:pathMatch(.*)*',
    ServerError = '/500'
}
